import Vue from 'vue';
import OutOfServiceHospital from '@/Classes/800/OutOfServiceHospital';
export default {
  data() {
    return {
      allActiveOutOfServiceHospitals: [],
      allActiveWithAlarmOutOfServiceHospitals: [],
    };
  },
  methods: {
    getListOfAllActiveOutOfServiceHospitalsFunction_OOLLDD: function () {
      if (this.$route.name == 'admissionMissions') {
        this.outOfServiceLoader = true;
      }
      this.$store.dispatch('getAllActiveOutOfServiceHospitals').then(() => {
        if (this.$store.state.outOfServiceHospitalModule.successFlag) {
          let temp = this.$store.state.outOfServiceHospitalModule.allActiveOutOfServiceHospitals;
          for (let i = 0; i < this.allActiveOutOfServiceHospitals.length; i++) {
            clearInterval(this.allActiveOutOfServiceHospitals[i].durationInterval);
          }
          this.allActiveOutOfServiceHospitals = [];
          for (let i = 0; i < temp.length; i++) {
            let hospitalPhoneNumbers = [];
            if (temp[i].hospital) {
              let tmpPhoneNumber = temp[i].hospital.phoneNumber.split(',');
              for (let j = 0; j < tmpPhoneNumber.length; j++) {
                if (tmpPhoneNumber[j] && tmpPhoneNumber[j] != ',') {
                  hospitalPhoneNumbers.push(tmpPhoneNumber[j]);
                }
              }
            }
            let createUser = '';
            if (temp[i].creationUser) {
              let fName = temp[i].creationUser.firstName;
              let lName = temp[i].creationUser.lastName;
              createUser = fName + ' ' + lName;
            }
            let duration = Number(temp[i].totalDuration) * 60;
            duration = duration * 1000;
            // let durationFlag = false;

            if (temp[i].hasAlarm) {
              let date1 = new Date(temp[i].currentDate);
              let date2 = new Date(temp[i].startDate);
              let tempDate = date2.getTime();
              let mainDate = Number(tempDate) + Number(duration);
              let dd = date1.getTime() - mainDate;
              duration = Number(dd);
            } else {
              let date1 = new Date(temp[i].currentDate);
              let date2 = new Date(temp[i].startDate);
              let dd = date1.getTime() - date2.getTime();
              if (duration > dd) {
                duration = Number(duration) - Number(dd);
                // durationFlag = true;
              }
            }


            this.allActiveOutOfServiceHospitals.push({
              id: temp[i].id,
              phoneNumber:
                temp[i].hospital && temp[i].hospital.phoneNumber
                  ? temp[i].hospital.phoneNumber
                  : '-',
              note: temp[i].note ? temp[i].note : '-',
              user: createUser,
              duration: duration,
              durationInterval: null,
              hospital: temp[i].hospital && temp[i].hospital.title ? temp[i].hospital.title : '-',
              hospitalPhoneNumbers: hospitalPhoneNumbers,
              hasAlarm: temp[i].hasAlarm ? temp[i].hasAlarm : false,
            });
            if (!temp[i].hasAlarm) {
              const index = this.allActiveOutOfServiceHospitals.length - 1;
              this.allActiveOutOfServiceHospitals[index].durationInterval = setInterval(() => {
                duration = duration - 1000;
                if (duration > 0) {
                  this.allActiveOutOfServiceHospitals[index].duration = this.msToTime(duration);
                } else {
                  this.allActiveOutOfServiceHospitals[index].duration = '00:00';
                  clearInterval(this.allActiveOutOfServiceHospitals[index].durationInterval);
                }
              }, 1000);
            } else {
              const index = this.allActiveOutOfServiceHospitals.length - 1;
              this.allActiveOutOfServiceHospitals[index].durationInterval = setInterval(
                () => {
                  duration = duration + 1000;
                  this.allActiveOutOfServiceHospitals[index].duration =
                    this.msToTime(duration);
                },
                1000,
              );
            }
          }
          if (this.$route.name == 'admissionMissions') {
            this.outOfServiceLoader = false;
          }
        } else {
          if (this.$route.name == 'admissionMissions') {
            this.outOfServiceLoader = false;
          }
          if (this.$store.state.outOfServiceHospitalModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getListOfAllActiveOutOfServiceHospitalsFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.outOfServiceHospitalModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getListOfAllActiveOutOfServiceHospitalsFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getListOfAllActiveOutOfServiceHospitalsFunction: function (islaod = true) {
      if (this.$route.name == 'admissionMissions' && islaod) {
        this.outOfServiceLoader = true;
      }
      return this.$store.dispatch('getAllActiveOutOfServiceHospitals').then(() => {
        if (this.$store.state.outOfServiceHospitalModule.successFlag) {
          const temp =
            this.$store.state.outOfServiceHospitalModule.allActiveOutOfServiceHospitals;

          // stop old per-row timers before rebuilding
          for (let i = 0; i < this.allActiveOutOfServiceHospitals.length; i++) {
            clearInterval(this.allActiveOutOfServiceHospitals[i].durationInterval);
          }

          const rows = [];

          for (let i = 0; i < temp.length; i++) {
            const hospitalPhoneNumbers = [];
            if (temp[i].hospital && temp[i].hospital.phoneNumber) {
              const tmpPhoneNumber = temp[i].hospital.phoneNumber.split(',');
              for (let j = 0; j < tmpPhoneNumber.length; j++) {
                if (tmpPhoneNumber[j] && tmpPhoneNumber[j] != ',') {
                  hospitalPhoneNumbers.push(tmpPhoneNumber[j]);
                }
              }
            }

            let createUser = '';
            if (temp[i].creationUser) {
              createUser =
                temp[i].creationUser.firstName + ' ' + temp[i].creationUser.lastName;
            }

            let duration = Number(temp[i].totalDuration) * 60 * 1000;

            if (temp[i].hasAlarm) {
              const date1 = new Date(temp[i].currentDate);
              const date2 = new Date(temp[i].startDate);
              const mainDate = Number(date2.getTime()) + Number(duration);
              duration = Number(date1.getTime() - mainDate);
            } else {
              const date1 = new Date(temp[i].currentDate);
              const date2 = new Date(temp[i].startDate);
              const dd = date1.getTime() - date2.getTime();
              if (duration > dd) {
                duration = Number(duration) - Number(dd);
              }
            }

            // NOT frozen — `duration` is mutated by the interval below
            const row = {
              id: temp[i].id,
              phoneNumber:
                temp[i].hospital && temp[i].hospital.phoneNumber
                  ? temp[i].hospital.phoneNumber
                  : '-',
              note: temp[i].note ? temp[i].note : '-',
              user: createUser,
              duration: duration,
              durationInterval: null,
              hospital:
                temp[i].hospital && temp[i].hospital.title ? temp[i].hospital.title : '-',
              hospitalPhoneNumbers: hospitalPhoneNumbers,
              hasAlarm: temp[i].hasAlarm ? temp[i].hasAlarm : false,
            };

            if (!temp[i].hasAlarm) {
              // countdown
              row.durationInterval = setInterval(() => {
                duration = duration - 1000;
                if (duration > 0) {
                  row.duration = this.msToTime(duration);
                } else {
                  row.duration = '00:00';
                  clearInterval(row.durationInterval);
                }
              }, 1000);
            } else {
              // count-up (overdue)
              row.durationInterval = setInterval(() => {
                duration = duration + 1000;
                row.duration = this.msToTime(duration);
              }, 1000);
            }

            rows.push(row);
          }

          // single reactive assignment — one re-render
          this.allActiveOutOfServiceHospitals = rows;

          if (this.$route.name == 'admissionMissions') {
            this.outOfServiceLoader = false;
          }
        } else {
          if (this.$route.name == 'admissionMissions') {
            this.outOfServiceLoader = false;
          }
          if (this.$store.state.outOfServiceHospitalModule.errorStatus) {
            return this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                return this.getListOfAllActiveOutOfServiceHospitalsFunction(islaod);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.outOfServiceHospitalModule.error400) {
            return this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                return this.getListOfAllActiveOutOfServiceHospitalsFunction(islaod);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getListOfAllActiveAlarmOutOfServiceHospitalsFunction: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllActiveAlarmOutOfServiceHospitals').then(() => {
        if (this.$store.state.outOfServiceHospitalModule.successFlag) {
          let temp =
            this.$store.state.outOfServiceHospitalModule.allActiveAlarmOutOfServiceHospitals;
          for (let i = 0; i < this.allActiveWithAlarmOutOfServiceHospitals.length; i++) {
            clearInterval(this.allActiveWithAlarmOutOfServiceHospitals[i].durationInterval);
          }
          this.allActiveWithAlarmOutOfServiceHospitals = [];
          for (let i = 0; i < temp.length; i++) {
            let time = '-';
            let user = '';
            if (temp[i].creationUser) {
              let fName = temp[i].creationUser.firstName;
              let lName = temp[i].creationUser.lastName;
              user = fName + ' ' + lName;
            }
            if (temp[i].startDate) {
              time = Vue.moment(temp[i].startDate).format('HH:mm:ss jYYYY/jM/jD');
            }
            let duration = Number(temp[i].totalDuration) * 60;
            duration = duration * 1000;
            let date1 = new Date(temp[i].currentDate);
            let date2 = new Date(temp[i].startDate);
            let tempDate = date2.getTime();
            let mainDate = Number(tempDate) + Number(duration);
            let dd = date1.getTime() - mainDate;
            duration = Number(dd);
            this.allActiveWithAlarmOutOfServiceHospitals.push({
              id: temp[i].id,
              hospital: temp[i].hospital && temp[i].hospital.title ? temp[i].hospital.title : '-',
              note: temp[i].note ? temp[i].note : '-',
              time: time,
              duration: duration,
              durationInterval: null,
              user: user,
            });
            const index = this.allActiveWithAlarmOutOfServiceHospitals.length - 1;
            this.allActiveWithAlarmOutOfServiceHospitals[index].durationInterval = setInterval(
              () => {
                duration = duration + 1000;
                this.allActiveWithAlarmOutOfServiceHospitals[index].duration =
                  this.msToTime(duration);
              },
              1000,
            );
          }
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.outOfServiceHospitalModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getListOfAllActiveAlarmOutOfServiceHospitalsFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.outOfServiceHospitalModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getListOfAllActiveAlarmOutOfServiceHospitalsFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    addOutOfServiceHospitalFunction: function () {
      if (!this.outOfServiceHospital.hospitalId) {
        this.snackText = 'بیمارستان نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.outOfServiceHospital.note) {
        this.snackText = 'توضیحات نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.outOfServiceHospital.note.replace(/\s/g, '').length) {
        this.snackText = 'توضیحات نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      let totalDuration = 0;
      let hour = Number(this.outOfServiceHospitalHour * 60);
      totalDuration = Number(hour) + Number(this.outOfServiceHospitalMinute);
      if (!totalDuration) {
        this.snackText = 'مدت زمان نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      this.outOfServiceHospital.totalDuration = Number(totalDuration);
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('addOutOfServiceHospital', this.outOfServiceHospital).then(() => {
        if (this.$store.state.outOfServiceHospitalModule.successFlag) {
          this.$refs.confirm.showConfirmDialog = false;
          this.addOutOfServiceModal = false;
          this.disabelConfirm = false;
          this.snackText = ' بیمارستان با موفقیت اضافه شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
          if (this.load.val) {
            this.load.val = false;
          }
          this.outOfServiceHospital = new OutOfServiceHospital.OutOfServiceHospital('', null, null);
          this.outOfServiceHospitalMinute = null;
          this.outOfServiceHospitalHour = null;
          this.getListOfAllActiveOutOfServiceHospitalsFunction();
          // this.getListOfAllActiveAlarmOutOfServiceHospitalsFunction();
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.outOfServiceHospitalModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.addOutOfServiceHospitalFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.outOfServiceHospitalModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.addOutOfServiceHospitalFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    extendOutOfServiceHospitalFunction: function () {
      let totalDuration = 0;
      let hour = Number(this.extendHour * 60);
      totalDuration = Number(hour) + Number(this.extendMinute);
      if (!totalDuration) {
        this.snackText = 'مدت زمان نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      let data = {
        id: Number(this.outOfServiceHospitalId),
        duration: Number(totalDuration),
      };
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('extendOutOfServiceHospital', data).then(() => {
        if (this.$store.state.outOfServiceHospitalModule.successFlag) {
          this.$refs.confirm.showConfirmDialog = false;
          this.extendTimeModal = false;
          this.disabelConfirm = false;
          this.snackText = ' زمان با موفقیت تمدید شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
          if (this.load.val) {
            this.load.val = false;
          }
          this.extendMinute = null;
          this.extendHour = null;
          this.getListOfAllActiveOutOfServiceHospitalsFunction();
          // this.getListOfAllActiveAlarmOutOfServiceHospitalsFunction();
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          this.disabelConfirm = false;
          if (this.$store.state.outOfServiceHospitalModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.extendOutOfServiceHospitalFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.outOfServiceHospitalModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.extendOutOfServiceHospitalFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    modifyOutOfServiceHospitalFunction: function (txtNote) {
      if (txtNote?.trim()?.length == 0) {
        this.snackText = 'توضیحات نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      let data = {
        id: Number(this.outOfServiceHospitalId),
        note: txtNote,
      };
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('modifyOutOfServiceHospital', data).then(() => {
        if (this.$store.state.outOfServiceHospitalModule.successFlag) {
          this.editNotemodal = false;
          this.snackText = ' توضیحات با موفقیت ثبت شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
          if (this.load.val) {
            this.load.val = false;
          }
          this.extendMinute = null;
          this.extendHour = null;
          this.getListOfAllActiveOutOfServiceHospitalsFunction();
          // this.getListOfAllActiveAlarmOutOfServiceHospitalsFunction();
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          this.disabelConfirm = false;
          if (this.$store.state.outOfServiceHospitalModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.modifyOutOfServiceHospitalFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.outOfServiceHospitalModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.modifyOutOfServiceHospitalFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },

    endOutOfServiceHospitalFunction: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('endOutOfServiceHospital', this.outOfServiceHospitalId).then(() => {
        if (this.$store.state.outOfServiceHospitalModule.successFlag) {
          this.disabelConfirm = false;
          this.$refs.confirm.showConfirmDialog = false;
          if (this.load.val) {
            this.load.val = false;
          }
          this.getListOfAllActiveOutOfServiceHospitalsFunction();
          // this.getListOfAllActiveAlarmOutOfServiceHospitalsFunction();
          this.snackText = ' تغییر وضعیت با موفقیت انجام شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.outOfServiceHospitalModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.endOutOfServiceHospitalFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.outOfServiceHospitalModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.endOutOfServiceHospitalFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
  },
};
